import $ from 'jquery';

const form = $( '.search-form--normal' ),
	searchBar = $( '.search-form__search-field' );

let form_submitted = false;

form.on( 'submit', ( e ) => {
	if ( !form_submitted ) {
		e.preventDefault();
		form_submitted = true;

		$.ajax( {
			type: 'GET',
			url: psh_vars.rest_route.factory_data_statis,
			data: {
				search: searchBar.val()
			},
			complete: function () {
				form.submit();
			}
		} );
	}
} );
